import { modes } from './';
import { DeviceTypesBasic, DeviceTypesExtended } from './types';
class MobileDetector {
    static mobile = {
        initialized: false,
        value: false
    };
    static android = {
        initialized: false,
        value: false
    };
    static iOS = {
        initialized: false,
        value: false
    };
    static tablet = {
        initialized: false,
        value: false
    };
    static isMobile() {
        if (!MobileDetector.mobile.initialized) {
            const search = new URLSearchParams(window.location.search);
            const isMobileApp = search.get('isMobileApp') || '';
            MobileDetector.mobile.value = (parseInt(isMobileApp) === 1 ||
                modes.isAppWSM2021() ||
                !!navigator.userAgent.match(/Android/i) ||
                !!navigator.userAgent.match(/webOS/i) ||
                !!navigator.userAgent.match(/iPhone/i) ||
                !!navigator.userAgent.match(/iPad/i) ||
                !!navigator.userAgent.match(/iPod/i) ||
                !!navigator.userAgent.match(/BlackBerry/i) ||
                !!navigator.userAgent.match(/Windows Phone/i));
            MobileDetector.mobile.initialized = true;
        }
        return MobileDetector.mobile.value;
    }
    static isIOS() {
        if (!MobileDetector.iOS.initialized) {
            MobileDetector.iOS.value = (!!navigator.userAgent.match(/iPhone/i) ||
                !!navigator.userAgent.match(/iPad/i) ||
                !!navigator.userAgent.match(/Mac OS/i));
            MobileDetector.iOS.initialized = true;
        }
        return MobileDetector.iOS.value;
    }
    static isAndroid() {
        if (!MobileDetector.android.initialized) {
            const userAgent = navigator.userAgent.toLowerCase();
            MobileDetector.android.value = userAgent.indexOf('android') !== -1;
            MobileDetector.android.initialized = true;
        }
        return MobileDetector.android.value;
    }
    static isTablet() {
        if (!MobileDetector.tablet.initialized) {
            MobileDetector.tablet.value = window.innerWidth / window.innerHeight <= 1.7;
            MobileDetector.tablet.initialized = true;
        }
        return MobileDetector.tablet.value;
    }
    static getDeviceTypeBasic() {
        return MobileDetector.isMobile() ? DeviceTypesBasic.mobile : DeviceTypesBasic.web;
    }
    static getDeviceTypeAdvanced() {
        if (MobileDetector.isMobile()) {
            if (MobileDetector.isIOS())
                return DeviceTypesExtended.ios;
            if (MobileDetector.isAndroid())
                return DeviceTypesExtended.android;
            return DeviceTypesExtended.otherMobile;
        }
        return DeviceTypesExtended.web;
    }
}
export { MobileDetector };
//# sourceMappingURL=MobileDetector.js.map